import { useSearchParams } from 'next/navigation';
import { useContext } from 'react';

import AnimatedScreenWrapper from '@/components/PreSignupFlow/Components/AnimatedScreenWrapper';
import SimplifiedSignup from '@/components/SimplifiedSignup';
import ControlFlow from '@/components/SimplifiedSignup/configs/Control/Flow';
import { SimplifiedSignupContextProvider } from '@/components/SimplifiedSignup/Context';
import { PaymentScreenConfig } from '@/components/SimplifiedSignup/Payment/types';

import { PreSignupFlowContext } from '../../PreSignupProvider';

const BundledSimplifiedSignup = () => {
	const searchParams = useSearchParams();
	const { focusedQuizMap = {}, isCheckoutSessionsEnabled } = useContext(PreSignupFlowContext);
	const focus = searchParams?.get('focus');
	if (focusedQuizMap[focus as string]) {
		const PaymentScreen: PaymentScreenConfig = ControlFlow.screens.payment as PaymentScreenConfig;
		// TODO: refactor this code to follow best practices
		// eslint-disable-next-line react-hooks/immutability
		PaymentScreen.limitedTimeOffer = false;
	}
	return (
		<AnimatedScreenWrapper isExiting={false}>
			<SimplifiedSignupContextProvider
				flowConfig={ControlFlow}
				isCheckoutSessionsEnabled={isCheckoutSessionsEnabled}
			>
				<SimplifiedSignup />
			</SimplifiedSignupContextProvider>
		</AnimatedScreenWrapper>
	);
};

export default BundledSimplifiedSignup;
